import { OrganisationsService } from '../../../services';
import { RoleService } from '../../../services';
import { UserService } from '../../../services';
import { IUser } from './../../../interfaces/user.d';
import { Component, OnInit } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { Message, SelectItem, TreeNode } from 'primeng';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'new-user',
  templateUrl: 'new-user.component.html',
})
export class NewUserComponent implements OnInit {
  public msgs: Message[];
  public userForm: UntypedFormGroup;

  public roles: SelectItem[];
  public organisations: SelectItem[];
  public departments: SelectItem[];
  public regions: SelectItem[];
  public teams: SelectItem[];
  public depots: SelectItem[];

  public selectedOrg: any;
  public selectedDepartmentOrRegion: any;
  public selectedTeamOrDepot: any;

  public orgType: number;

  constructor(
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private orgService: OrganisationsService,
    private roleService: RoleService,
    private location: Location,
  ) {}

  ngOnInit() {
    this.orgType = this.route.snapshot.params['orgType'];

    this.userForm = this.formBuilder.group({
      email: [
        '',
        Validators.compose([Validators.required, Validators.email, Validators.maxLength(254)]),
      ],
      phoneNumber: ['', Validators.compose([Validators.required, Validators.maxLength(20)])],
      firstName: ['', Validators.compose([Validators.required, Validators.maxLength(100)])],
      lastName: ['', Validators.compose([Validators.required, Validators.maxLength(100)])],
      userRoles: [[], Validators.required],
      organisationId: null,
      userOrganisationLevel: this.formBuilder.group({
        id: [0],
        userId: [''],
        organisationId: [null],
        supplierRegionId: [null],
        supplierDepotId: [null],
        customerDepartmentId: [null],
        customerTeamId: [null],
      }),
    });

    this.userService.getCurrentUserOrg().then((data) => {
      this.selectedOrg = data;

      this.loadRoles();

      this.loadDepartments();
      this.loadRegions();
    });

    this.msgs = [];
  }

  loadDepartments() {
    this.departments = [];
    this.departments.push({ label: 'Select Department...', value: '' });
    this.selectedOrg.departments.forEach((d) => {
      this.departments.push({ label: d.name, value: d.id });
    });
  }

  loadRegions() {
    this.regions = [];
    this.regions.push({ label: 'Select Region...', value: '' });
    this.selectedOrg.regions.forEach((d) => {
      this.regions.push({ label: d.name, value: d.id });
    });
  }

  loadTeams() {
    if (this.userForm.value.userOrganisationLevel.customerDepartmentId != null) {
      this.orgService
        .getDepartment(this.userForm.value.userOrganisationLevel.customerDepartmentId)
        .then((data) => {
          this.teams = [];
          this.teams.push({ label: 'Select Team...', value: '' });
          data.teams.forEach((t) => {
            this.teams.push({ label: t.name, value: t.id });
          });
        });
    }
  }

  loadDepots() {
    if (this.userForm.value.userOrganisationLevel.supplierRegionId != null) {
      this.orgService
        .getRegion(this.userForm.value.userOrganisationLevel.supplierRegionId)
        .then((data) => {
          this.depots = [];
          this.depots.push({ label: 'Select Depot...', value: '' });
          data.depots.forEach((d) => {
            this.depots.push({ label: d.name, value: d.id });
          });
        });
    }
  }

  loadRoles() {
    this.roleService.getRolesByOrg(this.selectedOrg.id, 1).then((data) => {
      this.roles = [];
      data.forEach((r) => {
        this.roles.push({ label: r.description, value: r });
      });
    });
  }

  /* No References, so commented out
  orgChange($event) {
    this.orgService.getOrg($event.value).then((data) => {
      this.selectedOrg = data;

      this.loadRoles();
      this.loadDepartments();
      this.loadRegions();
    });
  }

   */

  departmentChange($event) {
    this.loadTeams();
  }

  regionChange($event) {
    this.loadDepots();
  }

  invite(formValues) {
    var user = <IUser>formValues;

    this.userService.inviteUser(user).then((data) => {
      console.log(data);
      this.msgs = [];
      if (data.succeeded) {
        this.msgs.push({
          severity: 'success',
          summary: 'Success Message',
          detail: 'The invitation has been sent',
        });
      } else {
        this.msgs.push({
          severity: 'error',
          summary: 'Error Message',
          detail: data.errors.map((e) => e.description).join(';'),
        });
      }
    });
  }

  cancel() {
    this.location.back();
    //if (this.orgType == 2)
    //    this.router.navigate(['app/customerusers']);
    //else
    //    this.router.navigate(['app/supplierusers']);
  }
}
